var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg105Tiere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480.052,
    height: 480.052,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 378.511,
    width: 378.511,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(-92 24.579353332519506,398.29937744140625)",
    id: "svg_56",
    height: 29.516,
    width: 69.441,
    y: 383.541,
    x: -10.141,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(34 52.43261718750013,433.9817810058593)",
    id: "svg_55",
    height: 29.516,
    width: 75.607,
    y: 419.224,
    x: 14.629,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    ry: 98.15,
    rx: 99.884,
    id: "svg_53",
    cy: 329.451,
    cx: 183.494,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_41",
    height: 105.433,
    width: 178.959,
    y: 365.174,
    x: 266.038,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_40",
    height: 218.497,
    width: 58.959,
    y: 252.111,
    x: 266.038,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_43",
    height: 88.786,
    width: 24.277,
    y: 253.498,
    x: 252.165,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_52",
    height: 155.375,
    width: 165.78,
    y: 311.07,
    x: 76.674,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(-49 149.16752624511722,94.47914123535156)",
    id: "svg_57",
    height: 29.516,
    width: 74.97,
    y: 79.721,
    x: 111.683,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_51",
    height: 369.71,
    width: 58.959,
    y: 96.735,
    x: 183.494,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(-150 191.47961425781247,104.19010925292969)",
    id: "svg_59",
    height: 29.516,
    width: 74.97,
    y: 89.432,
    x: 153.995,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(-175 191.47961425781253,104.19010925292969)",
    id: "svg_60",
    height: 29.516,
    width: 74.97,
    y: 89.432,
    x: 153.995,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_49",
    height: 370.404,
    width: 58.959,
    y: 98.816,
    x: 200.142,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(-42 308.70489501953125,108.35195159912111)",
    id: "svg_61",
    height: 29.516,
    width: 74.97,
    y: 93.594,
    x: 271.22,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_50",
    height: 151.907,
    width: 58.959,
    y: 99.51,
    x: 234.824,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_46",
    height: 81.156,
    width: 20.116,
    y: 245.174,
    x: 220.951,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_42",
    height: 98.497,
    width: 33.988,
    y: 236.85,
    x: 229.968,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_45",
    height: 65.202,
    width: 24.277,
    y: 254.191,
    x: 337.483,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_44",
    height: 98.497,
    width: 33.988,
    y: 235.463,
    x: 316.673,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 41.272,
    rx: 22.89,
    id: "svg_47",
    cy: 420.318,
    cx: 445.69,
    strokeOpacity: "null",
    strokeWidth: "null",
    stroke: "null",
    fill: "#777f8e"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "rotate(-130 336.4505310058594,97.2537078857422)",
    id: "svg_58",
    height: 29.516,
    width: 74.97,
    y: 82.496,
    x: 298.966,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#193351",
    id: "svg_3",
    d: "m470.955,388.077c-16.888,-29.616 -47.84,-35.16 -53.88,-35.968c-0.352,-0.048 -0.704,-0.072 -1.064,-0.072l-84.688,0l-3.352,-3.352c4.312,-1.504 8.44,-3.472 12.264,-5.856c3.928,-2.448 7.264,-5.2 10.216,-8.056l31.36,8.96l4.392,-15.384l-25.088,-7.168c3.312,-5.656 5.392,-10.976 6.552,-14.832c0.224,-0.752 0.344,-1.528 0.344,-2.312l0,-16.44l19.152,-8.208l-6.296,-14.704l-12.856,5.512l0,-6.16c0,-1.448 -0.392,-2.872 -1.144,-4.12l-24,-40c-1.264,-2.112 -3.44,-3.52 -5.88,-3.824c-2.408,-0.264 -4.88,0.536 -6.632,2.288l-21.656,21.656l-4.688,0l0,-100.688l11.312,-11.312l10.264,0l21.984,14.656c3.68,2.456 8.64,1.456 11.096,-2.216l16,-24c1.792,-2.688 1.792,-6.184 0,-8.872l-32,-48c-1.488,-2.232 -3.984,-3.568 -6.656,-3.568l-24,0c-3.032,0 -5.8,1.712 -7.16,4.424l-13.784,27.576l-86.112,0l-13.792,-27.576c-1.352,-2.712 -4.12,-4.424 -7.152,-4.424l-32,0c-2.584,0 -5.008,1.248 -6.504,3.352l-40,56c-2.272,3.176 -1.912,7.536 0.848,10.304l16,16c2.696,2.704 6.92,3.104 10.096,1l21.984,-14.656l18.264,0l3.312,3.312l0,86.96c-21.12,7.672 -78.784,33.992 -103.48,98.888c-14.568,38.288 -11.336,74.032 -5.968,97.448l-18.552,-11.136l0,-27.472c0,-9.152 -5.088,-17.376 -13.264,-21.464c-8.192,-4.096 -17.824,-3.216 -25.144,2.272c-6.008,4.512 -9.592,11.688 -9.592,19.192l0,56c0,2.76 1.424,5.32 3.76,6.784l64,40c1.272,0.792 2.736,1.216 4.24,1.216l160,0l32,0l168,0c1.24,0 2.472,-0.288 3.576,-0.84l32,-16c1.448,-0.72 2.632,-1.864 3.416,-3.272c0.832,-1.488 19.968,-36.784 -0.048,-71.848zm-214.936,11.912l-47.376,-0.152l-0.048,16l47.416,0.152l0,48.048l-16,0c0,-17.648 -14.352,-32 -32,-32l-16,0c0,-39.696 -32.296,-72 -72,-72l-8,0l0,16l8,0c30.872,0 56,25.12 56,56l0,8c0,4.416 3.576,8 8,8l24,0c8.824,0 16,7.176 16,16l-149.704,0l-58.296,-36.432l0,-51.568c0,-2.504 1.192,-4.896 3.192,-6.4c2.48,-1.856 5.608,-2.144 8.384,-0.752c2.768,1.384 4.424,4.056 4.424,7.152l0,32c0,2.808 1.48,5.416 3.88,6.856l40,24c2.904,1.744 6.6,1.472 9.216,-0.696c2.608,-2.168 3.576,-5.736 2.408,-8.92c-5.984,-16.288 -17.968,-59.264 -0.032,-106.4c1.176,-3.096 2.512,-6.008 3.848,-8.912l0.016,0.008c26.936,-58.536 83.888,-78.832 95.04,-82.304c3.352,-1.032 5.624,-4.128 5.624,-7.632l0,-96c0,-2.12 -0.84,-4.16 -2.344,-5.656l-8,-8c-1.496,-1.504 -3.528,-2.344 -5.656,-2.344l-24,0c-1.576,0 -3.128,0.472 -4.44,1.344l-18.544,12.36l-6.568,-6.568l33.672,-47.136l22.936,0l13.792,27.576c1.352,2.712 4.12,4.424 7.152,4.424l96,0c3.032,0 5.8,-1.712 7.16,-4.424l13.784,-27.576l14.776,0l26.664,40l-8.6,12.904l-17.344,-11.56c-1.312,-0.872 -2.864,-1.344 -4.44,-1.344l-16,0c-2.128,0 -4.16,0.84 -5.656,2.344l-16,16c-1.504,1.496 -2.344,3.536 -2.344,5.656l0,104l-20.688,0l-21.656,-21.656c-1.744,-1.752 -4.2,-2.576 -6.632,-2.288c-2.448,0.304 -4.616,1.712 -5.88,3.824l-24,40c-0.752,1.248 -1.144,2.672 -1.144,4.12l0,6.16l-12.848,-5.504l-6.296,14.704l19.144,8.2l0,12.616l0,3.824c0,0.784 0.12,1.56 0.344,2.312c1.472,4.896 4.376,12.112 9.536,19.44l-28.688,10.76l5.624,14.984l34.832,-13.064c1.888,1.52 3.928,2.984 6.136,4.36c6.136,3.824 13.016,6.56 20.224,8.08l0,49.08zm202.008,50.096l-27.904,13.952l-72.352,0l-5.76,-17.296l0,-20.28l10.24,-15.36c1.272,-1.92 3.416,-3.064 5.712,-3.064c3.456,0 5.232,2.28 5.832,3.256c0.608,0.984 1.848,3.592 0.304,6.672l-5.248,10.496c-1.536,3.08 -0.936,6.8 1.504,9.232l8,8c1.496,1.504 3.528,2.344 5.656,2.344l40,0l0,-16l-36.688,0l-1.576,-1.576l2.672,-5.336c3.568,-7.136 3.184,-15.456 -1.008,-22.24c-4.192,-6.784 -11.472,-10.848 -19.448,-10.848c-7.656,0 -14.768,3.808 -19.024,10.176l-11.584,17.384c-0.872,1.32 -1.344,2.864 -1.344,4.44l0,24c0,0.856 0.144,1.712 0.416,2.528l4.488,13.472l-28.904,0l0,-56l-16,0l0,56l-24,0l0,-56.024l0,-63.976c0,-4.128 -3.144,-7.584 -7.256,-7.968c-5.856,-0.544 -11.352,-2.112 -16.432,-4.608l10.504,-3.936l-5.624,-14.984l-19.68,7.384c-5.192,-6.128 -8.048,-12.608 -9.512,-17.112l0,-2.608l0,-5.76l20.848,8.936l6.296,-14.704l-27.144,-11.624l0,-10.8l17.584,-29.312l16.76,16.752c1.496,1.504 3.528,2.344 5.656,2.344l32,0l16,0c2.128,0 4.16,-0.84 5.656,-2.344l16.76,-16.752l17.584,29.312l0,10.8l-27.152,11.632l6.296,14.704l20.856,-8.936l0,8.36c-1.2,3.688 -3.352,8.712 -6.928,13.784l-14.872,-4.248l-4.392,15.384l5.744,1.64c-6.104,3.752 -12.92,6.016 -20.288,6.704c-3.088,0.288 -5.736,2.336 -6.784,5.248c-1.056,2.92 -0.328,6.176 1.864,8.368l16,16c1.496,1.504 3.528,2.344 5.656,2.344l87.432,0c4.576,0.696 28.76,5.408 41.624,27.968c13.168,23.08 4.168,47.024 0.96,54.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.342273,198.309941c-0.767589,1.660784 -3.766396,2.263855 -4.988015,2.283724c-5.256856,0 -10.689431,-4.971832 -12.651282,-10.6864c7.380747,-1.854795 12.651282,-7.415089 12.651282,-14.246976c0,-8.387483 -7.887914,-14.959909 -17.957592,-14.959909s-17.957592,6.572425 -17.957592,14.959909c0,6.831886 5.270534,12.391596 12.651282,14.246976c-1.957642,5.714568 -7.389691,10.6864 -12.620242,10.6864c-1.288435,-0.019869 -4.224635,-0.623524 -5.045887,-2.338654c-1.162695,-2.433323 -3.878983,-3.356045 -6.06969,-2.064584s-3.025638,4.308571 -1.858734,6.741893c3.546484,7.420348 11.991544,7.634813 12.943271,7.634813c6.971963,0 13.715069,-4.423107 17.957592,-10.751266c4.242522,6.328158 10.985629,10.751266 17.957592,10.751266c0.96067,0 9.499904,-0.219139 12.970103,-7.689159c1.135864,-2.448516 0.269367,-5.455107 -1.93502,-6.716765s-4.906995,-0.305042 -6.047068,2.148734l0,-0.000002zm-22.945607,-17.662627c-5.396274,0 -8.979059,-3.001916 -8.979059,-4.986441c0,-1.984525 3.582785,-4.986441 8.979059,-4.986441c5.481503,0 8.979059,2.952244 8.979059,4.986441c0,2.034197 -3.497556,4.986441 -8.979059,4.986441z",
    id: "svg_1",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.599154,140.75403c3.712733,0 6.734163,-3.356045 6.734163,-7.479954s-3.021429,-7.479954 -6.734163,-7.479954c-3.712733,0 -6.734163,3.356045 -6.734163,7.479954s3.021429,7.479954 6.734163,7.479954z",
    id: "svg_2",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.194178,140.75403c3.712733,0 6.734163,-3.356045 6.734163,-7.479954s-3.021429,-7.479954 -6.734163,-7.479954s-6.734163,3.356045 -6.734163,7.479954s3.021429,7.479954 6.734163,7.479954z",
    id: "svg_4",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_27"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#193351",
    id: "svg_5",
    d: "m312.606819,266.079492c-2.952449,0 -5.355157,2.402732 -5.355157,5.35521s2.402708,5.35521 5.355157,5.35521s5.355157,-2.402732 5.355157,-5.35521s-2.402708,-5.35521 -5.355157,-5.35521z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#193351",
    id: "svg_6",
    d: "m271.550754,271.434703c0,-2.952478 -2.402708,-5.35521 -5.355157,-5.35521s-5.355157,2.402732 -5.355157,5.35521s2.402708,5.35521 5.355157,5.35521s5.355157,-2.402732 5.355157,-5.35521z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#193351",
    id: "svg_7",
    d: "m312.456624,312.887797c-1.756324,-0.903273 -3.905499,-0.214208 -4.808764,1.538786c-0.61417,1.189024 -2.998888,1.620788 -3.966582,1.635013c-4.34479,0 -8.850234,-3.841527 -10.239228,-8.132808c6.283524,-3.066695 10.239228,-12.57052 10.239228,-16.858035c0,-7.14042 -7.91852,-7.14042 -14.280279,-7.14042c-6.361759,0 -14.280279,0 -14.280279,7.14042c0,4.287934 3.955704,13.79134 10.239228,16.858035c-1.388575,4.291281 -5.894438,8.132808 -10.239228,8.132808c-0.507066,0 -3.234431,-0.29621 -4.009255,-1.713667c-0.945938,-1.727892 -3.113103,-2.363405 -4.844744,-1.417457c-1.727875,0.945948 -2.367147,3.113134 -1.417443,4.844792c2.884673,5.273209 9.525067,5.426753 10.271024,5.426753c5.544261,0 10.90653,-3.166687 14.280279,-7.697278c3.373749,4.530592 8.736018,7.697278 14.280279,7.697278c0.763947,0 7.554537,-0.156891 10.314116,-5.504989c0.903683,-1.753413 0.214625,-3.905957 -1.538353,-4.80923zm-23.055625,-11.106623c-2.945336,0 -6.758376,-7.118665 -7.115247,-10.282004c1.345902,-0.428417 4.76609,-0.428417 7.115247,-0.428417s5.772692,0 7.115247,0.428417c-0.346412,3.148696 -4.166145,10.282004 -7.115247,10.282004z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg105Tiere);
export default __webpack_public_path__ + "static/media/105 Tiere.9bcc3b8b57c6e01ad718255bbe38fe78.svg";
export { ForwardRef as ReactComponent };